// Pull-outs from Job.verdict for row/column rendering. The persisted
// record (controller/pkg/api VerdictSummary → model.Job.Verdict JSONB)
// carries `tags` as a string[] of ids and `signature` as a plain string;
// the live-stream verdict event carries full Tag objects. Normalize both
// here so a table cell doesn't have to care.
import type { Job, Tag } from "@/types";

export function tagNames(job: Job): string[] {
  const v = job.verdict;
  const t = (v as unknown as { tags?: unknown })?.tags;
  if (!Array.isArray(t)) return [];
  return t.flatMap((x): string[] => {
    if (typeof x === "string") return [x];
    if (x && typeof x === "object" && typeof (x as Tag).id === "string") return [(x as Tag).id];
    return [];
  });
}

export function signatureOf(job: Job): string | undefined {
  const v = job.verdict as unknown as { signature?: unknown } | undefined;
  const s = v?.signature;
  return typeof s === "string" && s !== "" ? s : undefined;
}
